import useCrud from '../useCrud'

const useUserType = () => {
  const { findById: getUserType } = useCrud('/admin/v1/user_types')

  return { getUserType }
}

export default useUserType
